let imchargelist5 = [
  { title: "Charges", label: "danggoodch", in: true, out: true },
  { title: "Handeling Fees", label: "danghandch", in: true, out: true },
];
export default imchargelist5;
